import {User} from 'constants/UserConstants';

export enum WritableAssayValidationStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
}
export enum ReadableAssayValidationStatus {
  VALID = 'VALID',
  PARTIALLY_VALID = 'PARTIALLY_VALID',
  INVALID = 'INVALID',
}

export const STATUS_TO_NAME = {
  [WritableAssayValidationStatus.VALID]: 'Valid',
  [WritableAssayValidationStatus.INVALID]: 'Invalid',
};

export type AssayValidationComment = string | null;

export interface CurrentAssayValidation {
  status: ReadableAssayValidationStatus;
  comment: AssayValidationComment;
}

export interface AssayValidationChange {
  status: WritableAssayValidationStatus;
  comment: AssayValidationComment;
  creator: User;
  createdAt: string;
}

export type AssayValidationHistory = Array<AssayValidationChange>;
interface AssayValidationWithHistory extends CurrentAssayValidation {
  history: AssayValidationHistory;
}

export type AssayRunValidation = AssayValidationWithHistory;
export type AssayResultFieldValidation = AssayValidationWithHistory;

export interface AssayResultValidation extends CurrentAssayValidation {
  fieldValidation: {[schemaFieldApiId: string]: AssayResultFieldValidation};
}

export interface AssayValidationByResultId {
  [resultId: string]: AssayResultValidation;
}

export interface FieldHasValueDictByResultId {
  [resultId: string]: {[schemaFieldApiId: string]: boolean};
}

export interface AssayValidationDisplayInfo {
  status: ReadableAssayValidationStatus;
  comment: AssayValidationComment;
  history?: AssayValidationHistory;
}

export enum ValidatableInputType {
  RUN = 'RUN',
  RESULT = 'RESULT',
  RESULT_FIELD = 'RESULT_FIELD',
}

export interface RunValidatableInput {
  type: ValidatableInputType.RUN;
  assayRunId: string;
  assayResultId: null;
  schemaFieldId: null;
}
export interface ResultValidatableInput {
  type: ValidatableInputType.RESULT;
  assayRunId: null;
  assayResultId: string;
  schemaFieldId: null;
}
export interface ResultFieldValidatableInput {
  type: ValidatableInputType.RESULT_FIELD;
  assayRunId: null;
  assayResultId: string;
  schemaFieldId: string;
}
export type ValidatableInput = RunValidatableInput | ResultValidatableInput | ResultFieldValidatableInput;
